// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MultiSelectPanel__container-d44105 {
  padding: 16px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.MultiSelectPanel__action-container-c7e20f {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.MultiSelectPanel__message-count-c0d289 {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.MultiSelectPanel__counter-c22a04 {
  color: var(--base-110);
  margin-inline-start: 16px;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body);
}

.MultiSelectPanel__indent-ed8986 {
  margin-inline-start: 4px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/MultiSelectPanel/MultiSelectPanel.styles.m.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,wCAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".container {\n  padding: 16px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.action-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.message-count {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.counter {\n  color: var(--base-110);\n  margin-inline-start: 16px;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body);\n}\n\n.indent {\n  margin-inline-start: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MultiSelectPanel__container-d44105`,
	"action-container": `MultiSelectPanel__action-container-c7e20f`,
	"actionContainer": `MultiSelectPanel__action-container-c7e20f`,
	"message-count": `MultiSelectPanel__message-count-c0d289`,
	"messageCount": `MultiSelectPanel__message-count-c0d289`,
	"counter": `MultiSelectPanel__counter-c22a04`,
	"indent": `MultiSelectPanel__indent-ed8986`
};
module.exports = ___CSS_LOADER_EXPORT___;
